import {Link} from "react-router-dom";
import ProgressBar from "../progressBar/ProgressBar";
import Spinner from "../spinner/Spinner";
import useGetProfilePicture from "../../hooks/useGetProfilePicture";
import LeaderBoardStyles from "./LeaderBoardStyles.module.css";
import DefaultImage from "../../assets/img/default-profile-photo.png";
import {LeaderboardThirtyDaysDataProps} from "../../types/ComponentProps";
import {getLevel} from "../../utils/getLevel";

type LeaderboardDaysCardProps = {
  data: LeaderboardThirtyDaysDataProps;
};

const ThirtyDaysCard = ({data}: LeaderboardDaysCardProps) => {
  const {
    points,
    user: { id: userId, preferredName, lastName, email },
  } = data;

  const {getProfileImage, error, isLoading, isFetching} =
    useGetProfilePicture(userId);
  const levelName = getLevel(points);

  return (
    <div
      className={`${LeaderBoardStyles.leaderboardCard} leaderboard-card-blk`}>
      {isLoading || isFetching ? (
        <Spinner
          addedStyles={{marginTop: "6px"}}
          variant="extra-small-spinner"
          alignSpin="center-spinner"
        />
      ) : (
        <Link to={`/profile/${userId}`}>
          <img
            alt="profile"
            src={error ? DefaultImage : getProfileImage?.profileImage}
          />
        </Link>
      )}
      <div>
        <Link
          to={`/profile/${userId}`}
          className={LeaderBoardStyles.leaderboardLinkText}>
          <h3 className={LeaderBoardStyles.nameSection}>
            {`${preferredName} ${lastName}`}
          </h3>
        </Link>
        <ProgressBar
          width={points === 0 ? 0 : levelName?.percentage ?? 0}
          points={points}
        />
      </div>
    </div>
  );
};

export default ThirtyDaysCard;